import { GET_FOOTER_PARTNERS } from "../../constants/footerPartners";
import * as feeds from "../../apis/services/feeds";

export const getFooterPartners = () => ({
  type: GET_FOOTER_PARTNERS,
  payload: feeds.getFooterPartners(),
});
